import { createContext, useContext } from 'react';

type SplitPaneContextValue = {
  /** Expand the right pane if it is currently collapsed. No-op otherwise. */
  expandRightPane: () => void;
};

const SplitPaneContext = createContext<SplitPaneContextValue>({
  expandRightPane: () => undefined,
});

export const SplitPaneProvider = SplitPaneContext.Provider;

export const useSplitPane = (): SplitPaneContextValue =>
  useContext(SplitPaneContext);
